import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../core/api.service';
import { CalendarEvent } from '../../core/models';

@Component({
  selector: 'app-calendar',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss',
})
export class CalendarComponent implements OnInit {
  private api = inject(ApiService);
  events = signal<CalendarEvent[]>([]);
  monthLabel = '';
  days: { date: Date; events: CalendarEvent[] }[] = [];

  ngOnInit(): void {
    this.api.get<CalendarEvent[]>('/api/tasks/calendar').subscribe((events) => {
      this.events.set(events);
      this.buildMonth(new Date(), events);
    });
  }

  buildMonth(anchor: Date, events: CalendarEvent[]): void {
    const year = anchor.getFullYear();
    const month = anchor.getMonth();
    this.monthLabel = anchor.toLocaleDateString('it-IT', { month: 'long', year: 'numeric' });
    const first = new Date(year, month, 1);
    const startPad = (first.getDay() + 6) % 7; // Monday-first
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const cells: { date: Date; events: CalendarEvent[] }[] = [];

    for (let i = 0; i < startPad; i++) {
      const d = new Date(year, month, 1 - (startPad - i));
      cells.push({ date: d, events: [] });
    }
    for (let day = 1; day <= daysInMonth; day++) {
      const d = new Date(year, month, day);
      const dayEvents = events.filter((e) => {
        const s = new Date(e.start);
        return s.getFullYear() === year && s.getMonth() === month && s.getDate() === day;
      });
      cells.push({ date: d, events: dayEvents });
    }
    while (cells.length % 7 !== 0) {
      const last = cells[cells.length - 1].date;
      const d = new Date(last);
      d.setDate(d.getDate() + 1);
      cells.push({ date: d, events: [] });
    }
    this.days = cells;
  }

  inMonth(d: Date): boolean {
    const now = new Date();
    // Use monthLabel's month from first in-month day roughly via events month
    const mid = this.days.find((c) => c.date.getDate() === 15) || this.days[10];
    return mid ? d.getMonth() === mid.date.getMonth() : true;
  }
}
